class SidecartDrawer extends HTMLElement {
  connectedCallback() {
    const btnClose = this.querySelector('.sd-close-btn');
    const overlay = this.querySelector('.sd-overlay');
    const panel = this.querySelector('.sd-panel');

    const closeDrawer = () => {
      overlay.classList.remove('is-open');
      panel.classList.remove('is-open');
      // Flyt fokus væk fra panel/knap før aria-hidden, brug setTimeout for at sikre browseren opdaterer fokus
      const cartIcon =
        document.getElementById('header-cart-icon') || document.getElementById('header-cart-icon-mobile');
      // Fjern fokus fra knappen hvis den har fokus
      if (document.activeElement === btnClose) {
        btnClose.blur();
      }
      // Flyt fokus væk fra panel/knap før aria-hidden, brug setTimeout for at sikre browseren opdaterer fokus
      if (cartIcon) {
        cartIcon.focus();
      } else {
        document.body.setAttribute('tabindex', '-1');
        document.body.focus();
      }
      setTimeout(() => {
        panel.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
      }, 0);
    };

    // Close actions
    btnClose.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDrawer();
    });

    // Fjernet eventlistener for header-cart-icon fra komponenten
  }
}

customElements.define('sidecart-drawer', SidecartDrawer);

// Global eventlistener til at åbne sidecart (desktop og mobile ikoner)
document.addEventListener('DOMContentLoaded', function () {
  const triggers = [
    document.getElementById('header-cart-icon'),
    document.getElementById('header-cart-icon-mobile'),
  ].filter(Boolean);
  const sidecartDrawer = document.querySelector('sidecart-drawer');
  const sideCartComponent = document.querySelector('side-cart');

  // Lightweight i18n bootstrap for cart messages, sourced from a JSON script tag rendered in sidecart.liquid
  let cartI18n = null;
  const i18nEl = document.getElementById('i18n-cart');
  if (i18nEl) {
    try {
      cartI18n = JSON.parse(i18nEl.textContent);
    } catch (e) {
      console.warn('Failed to parse i18n cart JSON:', e);
    }
  }
  // Expose a minimal helper for other scripts (like cart.js) without touching global layout
  window.__cartI18n = cartI18n || {};

  triggers.forEach((trigger) => {
    if (trigger && sidecartDrawer && sideCartComponent) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        // Åbn drawer (manuel fallback)
        const panel = sidecartDrawer.querySelector('.sd-panel');
        const overlay = sidecartDrawer.querySelector('.sd-overlay');
        if (panel && overlay) {
          panel.classList.add('is-open');
          overlay.classList.add('is-open');
          panel.setAttribute('aria-hidden', 'false');
          document.documentElement.style.overflow = 'hidden';
        }
        // Opdater cart-indhold
        sideCartComponent.getCart();
      });
    }
  });
});

/* ============================
   Global popup initializer
   ============================ */
document.addEventListener('DOMContentLoaded', function () {
  // Stop på checkout-sider
  if (window.Shopify && window.Shopify.Checkout) return;

  const popup = document.getElementById('site-popup');
  if (!popup) return;

  // Guard mod dobbelt init (Shopify editor / re-render)
  if (popup.dataset.initialized === 'true') return;
  popup.dataset.initialized = 'true';

  const STORAGE_KEY = 'sitePopupSeen';
  if (localStorage.getItem(STORAGE_KEY)) return;

  const delay = Number(popup.dataset.delay) || 1500;
  const closeBtn = popup.querySelector('.site-popup__close');
  const overlay = popup.querySelector('.site-popup__overlay');

  const closePopup = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    popup.remove();
    document.documentElement.classList.remove('popup-open');
  };

  setTimeout(() => {
    popup.hidden = false;
    popup.classList.add('is-open');
    document.documentElement.classList.add('popup-open');
  }, delay);

  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (overlay) overlay.addEventListener('click', closePopup);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closePopup();
  });
});
